import * as i0 from '@angular/core';
import { inject, ElementRef, booleanAttribute, Component, ChangeDetectionStrategy, Input, Injectable, TemplateRef, Directive, InjectionToken, ChangeDetectorRef, EventEmitter, ViewEncapsulation, ViewChild, ContentChild, ContentChildren, Output, NgModule } from '@angular/core';
import { DOCUMENT, NgTemplateOutlet, CommonModule } from '@angular/common';
import * as i2 from '@angular/forms';
import { Validators, NgControl, NgForm, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i1 from '@ng-select/ng-select';
import { NgSelectModule } from '@ng-select/ng-select';
import { FocusMonitor } from '@angular/cdk/a11y';
import { ErrorStateMatcher, _ErrorStateTracker } from '@angular/material/core';
import { MAT_FORM_FIELD, MatFormFieldControl } from '@angular/material/form-field';
import { Subject, Subscription, merge } from 'rxjs';
import { takeUntil, startWith } from 'rxjs/operators';
const _c0 = ["*"];
const _c1 = ["ngSelect"];
const _c2 = () => ({
  standalone: true
});
const _c3 = (a0, a1, a2, a3) => ({
  item: a0,
  item$: a1,
  index: a2,
  searchTerm: a3
});
const _c4 = (a0, a1, a2) => ({
  item: a0,
  clear: a1,
  label: a2
});
const _c5 = (a0, a1) => ({
  items: a0,
  clear: a1
});
const _c6 = a0 => ({
  searchTerm: a0
});
function MtxSelect_Conditional_2_ng_template_0_ng_template_0_Template(rf, ctx) {}
function MtxSelect_Conditional_2_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxSelect_Conditional_2_ng_template_0_ng_template_0_Template, 0, 0, "ng-template", 15);
  }
  if (rf & 2) {
    const item_r2 = ctx.item;
    const item$_r3 = ctx.item$;
    const index_r4 = ctx.index;
    const searchTerm_r5 = ctx.searchTerm;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r5.optionTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction4(2, _c3, item_r2, item$_r3, index_r4, searchTerm_r5));
  }
}
function MtxSelect_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxSelect_Conditional_2_ng_template_0_Template, 1, 7, "ng-template", 2);
  }
}
function MtxSelect_Conditional_3_ng_template_0_ng_template_0_Template(rf, ctx) {}
function MtxSelect_Conditional_3_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxSelect_Conditional_3_ng_template_0_ng_template_0_Template, 0, 0, "ng-template", 15);
  }
  if (rf & 2) {
    const item_r7 = ctx.item;
    const item$_r8 = ctx.item$;
    const index_r9 = ctx.index;
    const searchTerm_r10 = ctx.searchTerm;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r5.optgroupTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction4(2, _c3, item_r7, item$_r8, index_r9, searchTerm_r10));
  }
}
function MtxSelect_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxSelect_Conditional_3_ng_template_0_Template, 1, 7, "ng-template", 3);
  }
}
function MtxSelect_Conditional_4_ng_template_0_ng_template_0_Template(rf, ctx) {}
function MtxSelect_Conditional_4_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxSelect_Conditional_4_ng_template_0_ng_template_0_Template, 0, 0, "ng-template", 15);
  }
  if (rf & 2) {
    const item_r11 = ctx.item;
    const clear_r12 = ctx.clear;
    const label_r13 = ctx.label;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r5.labelTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c4, item_r11, clear_r12, label_r13));
  }
}
function MtxSelect_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxSelect_Conditional_4_ng_template_0_Template, 1, 6, "ng-template", 4);
  }
}
function MtxSelect_Conditional_5_ng_template_0_ng_template_0_Template(rf, ctx) {}
function MtxSelect_Conditional_5_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxSelect_Conditional_5_ng_template_0_ng_template_0_Template, 0, 0, "ng-template", 15);
  }
  if (rf & 2) {
    const items_r14 = ctx.items;
    const clear_r15 = ctx.clear;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r5.multiLabelTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c5, items_r14, clear_r15));
  }
}
function MtxSelect_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxSelect_Conditional_5_ng_template_0_Template, 1, 5, "ng-template", 5);
  }
}
function MtxSelect_Conditional_6_ng_template_0_ng_template_0_Template(rf, ctx) {}
function MtxSelect_Conditional_6_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxSelect_Conditional_6_ng_template_0_ng_template_0_Template, 0, 0, "ng-template", 16);
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r5.headerTemplate);
  }
}
function MtxSelect_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxSelect_Conditional_6_ng_template_0_Template, 1, 1, "ng-template", 6);
  }
}
function MtxSelect_Conditional_7_ng_template_0_ng_template_0_Template(rf, ctx) {}
function MtxSelect_Conditional_7_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxSelect_Conditional_7_ng_template_0_ng_template_0_Template, 0, 0, "ng-template", 16);
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r5.footerTemplate);
  }
}
function MtxSelect_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxSelect_Conditional_7_ng_template_0_Template, 1, 1, "ng-template", 7);
  }
}
function MtxSelect_Conditional_8_ng_template_0_ng_template_0_Template(rf, ctx) {}
function MtxSelect_Conditional_8_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxSelect_Conditional_8_ng_template_0_ng_template_0_Template, 0, 0, "ng-template", 15);
  }
  if (rf & 2) {
    const searchTerm_r16 = ctx.searchTerm;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r5.notFoundTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c6, searchTerm_r16));
  }
}
function MtxSelect_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxSelect_Conditional_8_ng_template_0_Template, 1, 4, "ng-template", 8);
  }
}
function MtxSelect_Conditional_9_ng_template_0_ng_template_0_Template(rf, ctx) {}
function MtxSelect_Conditional_9_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxSelect_Conditional_9_ng_template_0_ng_template_0_Template, 0, 0, "ng-template", 16);
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r5.typeToSearchTemplate);
  }
}
function MtxSelect_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxSelect_Conditional_9_ng_template_0_Template, 1, 1, "ng-template", 9);
  }
}
function MtxSelect_Conditional_10_ng_template_0_ng_template_0_Template(rf, ctx) {}
function MtxSelect_Conditional_10_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxSelect_Conditional_10_ng_template_0_ng_template_0_Template, 0, 0, "ng-template", 15);
  }
  if (rf & 2) {
    const searchTerm_r17 = ctx.searchTerm;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r5.loadingTextTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c6, searchTerm_r17));
  }
}
function MtxSelect_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxSelect_Conditional_10_ng_template_0_Template, 1, 4, "ng-template", 10);
  }
}
function MtxSelect_Conditional_11_ng_template_0_ng_template_0_Template(rf, ctx) {}
function MtxSelect_Conditional_11_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxSelect_Conditional_11_ng_template_0_ng_template_0_Template, 0, 0, "ng-template", 15);
  }
  if (rf & 2) {
    const searchTerm_r18 = ctx.searchTerm;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r5.tagTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c6, searchTerm_r18));
  }
}
function MtxSelect_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxSelect_Conditional_11_ng_template_0_Template, 1, 4, "ng-template", 11);
  }
}
function MtxSelect_Conditional_12_ng_template_0_ng_template_0_Template(rf, ctx) {}
function MtxSelect_Conditional_12_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxSelect_Conditional_12_ng_template_0_ng_template_0_Template, 0, 0, "ng-template", 16);
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r5.loadingSpinnerTemplate);
  }
}
function MtxSelect_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxSelect_Conditional_12_ng_template_0_Template, 1, 1, "ng-template", 12);
  }
}
function MtxSelect_Conditional_13_ng_template_0_ng_template_0_Template(rf, ctx) {}
function MtxSelect_Conditional_13_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxSelect_Conditional_13_ng_template_0_ng_template_0_Template, 0, 0, "ng-template", 16);
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r5.placeholderTemplate);
  }
}
function MtxSelect_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxSelect_Conditional_13_ng_template_0_Template, 1, 1, "ng-template", 13);
  }
}
function MtxSelect_Conditional_14_ng_template_0_ng_template_0_Template(rf, ctx) {}
function MtxSelect_Conditional_14_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxSelect_Conditional_14_ng_template_0_ng_template_0_Template, 0, 0, "ng-template", 16);
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r5.clearbuttonTemplate);
  }
}
function MtxSelect_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxSelect_Conditional_14_ng_template_0_Template, 1, 1, "ng-template", 14);
  }
}
let MtxOption = /*#__PURE__*/(() => {
  class MtxOption {
    constructor() {
      this.elementRef = inject(ElementRef);
      this.disabled = false;
      this.stateChange$ = new Subject();
    }
    get label() {
      return (this.elementRef.nativeElement.textContent || '').trim();
    }
    ngOnChanges(changes) {
      if (changes.disabled) {
        this.stateChange$.next({
          value: this.value,
          disabled: this.disabled
        });
      }
    }
    ngAfterViewChecked() {
      if (this.label !== this._previousLabel) {
        this._previousLabel = this.label;
        this.stateChange$.next({
          value: this.value,
          disabled: this.disabled,
          label: this.elementRef.nativeElement.innerHTML
        });
      }
    }
    ngOnDestroy() {
      this.stateChange$.complete();
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MtxOption_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxOption)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MtxOption,
        selectors: [["mtx-option"]],
        inputs: {
          value: "value",
          disabled: [2, "disabled", "disabled", booleanAttribute]
        },
        exportAs: ["mtxOption"],
        features: [i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function MtxOption_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return MtxOption;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MtxSelectIntl = /*#__PURE__*/(() => {
  class MtxSelectIntl {
    constructor() {
      this._defaultOptions = inject(MTX_SELECT_DEFAULT_OPTIONS, {
        optional: true
      });
      /**
       * Stream to emit from when labels are changed. Use this to notify components when the labels have
       * changed after initialization.
       */
      this.changes = new Subject();
      this.placeholder = this._defaultOptions?.placeholder;
      this.notFoundText = this._defaultOptions?.notFoundText ?? 'No items found';
      this.typeToSearchText = this._defaultOptions?.typeToSearchText ?? 'Type to search';
      this.addTagText = this._defaultOptions?.addTagText ?? 'Add item';
      this.loadingText = this._defaultOptions?.loadingText ?? 'Loading...';
      this.clearAllText = this._defaultOptions?.clearAllText ?? 'Clear all';
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MtxSelectIntl_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxSelectIntl)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: MtxSelectIntl,
        factory: MtxSelectIntl.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return MtxSelectIntl;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MtxSelectOptionTemplate = /*#__PURE__*/(() => {
  class MtxSelectOptionTemplate {
    constructor() {
      this.template = inject(TemplateRef);
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MtxSelectOptionTemplate_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxSelectOptionTemplate)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: MtxSelectOptionTemplate,
        selectors: [["", "ng-option-tmp", ""]]
      });
    }
  }
  return MtxSelectOptionTemplate;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MtxSelectOptgroupTemplate = /*#__PURE__*/(() => {
  class MtxSelectOptgroupTemplate {
    constructor() {
      this.template = inject(TemplateRef);
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MtxSelectOptgroupTemplate_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxSelectOptgroupTemplate)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: MtxSelectOptgroupTemplate,
        selectors: [["", "ng-optgroup-tmp", ""]]
      });
    }
  }
  return MtxSelectOptgroupTemplate;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MtxSelectLabelTemplate = /*#__PURE__*/(() => {
  class MtxSelectLabelTemplate {
    constructor() {
      this.template = inject(TemplateRef);
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MtxSelectLabelTemplate_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxSelectLabelTemplate)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: MtxSelectLabelTemplate,
        selectors: [["", "ng-label-tmp", ""]]
      });
    }
  }
  return MtxSelectLabelTemplate;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MtxSelectMultiLabelTemplate = /*#__PURE__*/(() => {
  class MtxSelectMultiLabelTemplate {
    constructor() {
      this.template = inject(TemplateRef);
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MtxSelectMultiLabelTemplate_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxSelectMultiLabelTemplate)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: MtxSelectMultiLabelTemplate,
        selectors: [["", "ng-multi-label-tmp", ""]]
      });
    }
  }
  return MtxSelectMultiLabelTemplate;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MtxSelectHeaderTemplate = /*#__PURE__*/(() => {
  class MtxSelectHeaderTemplate {
    constructor() {
      this.template = inject(TemplateRef);
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MtxSelectHeaderTemplate_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxSelectHeaderTemplate)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: MtxSelectHeaderTemplate,
        selectors: [["", "ng-header-tmp", ""]]
      });
    }
  }
  return MtxSelectHeaderTemplate;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MtxSelectFooterTemplate = /*#__PURE__*/(() => {
  class MtxSelectFooterTemplate {
    constructor() {
      this.template = inject(TemplateRef);
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MtxSelectFooterTemplate_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxSelectFooterTemplate)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: MtxSelectFooterTemplate,
        selectors: [["", "ng-footer-tmp", ""]]
      });
    }
  }
  return MtxSelectFooterTemplate;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MtxSelectNotFoundTemplate = /*#__PURE__*/(() => {
  class MtxSelectNotFoundTemplate {
    constructor() {
      this.template = inject(TemplateRef);
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MtxSelectNotFoundTemplate_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxSelectNotFoundTemplate)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: MtxSelectNotFoundTemplate,
        selectors: [["", "ng-notfound-tmp", ""]]
      });
    }
  }
  return MtxSelectNotFoundTemplate;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MtxSelectTypeToSearchTemplate = /*#__PURE__*/(() => {
  class MtxSelectTypeToSearchTemplate {
    constructor() {
      this.template = inject(TemplateRef);
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MtxSelectTypeToSearchTemplate_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxSelectTypeToSearchTemplate)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: MtxSelectTypeToSearchTemplate,
        selectors: [["", "ng-typetosearch-tmp", ""]]
      });
    }
  }
  return MtxSelectTypeToSearchTemplate;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MtxSelectLoadingTextTemplate = /*#__PURE__*/(() => {
  class MtxSelectLoadingTextTemplate {
    constructor() {
      this.template = inject(TemplateRef);
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MtxSelectLoadingTextTemplate_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxSelectLoadingTextTemplate)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: MtxSelectLoadingTextTemplate,
        selectors: [["", "ng-loadingtext-tmp", ""]]
      });
    }
  }
  return MtxSelectLoadingTextTemplate;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MtxSelectTagTemplate = /*#__PURE__*/(() => {
  class MtxSelectTagTemplate {
    constructor() {
      this.template = inject(TemplateRef);
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MtxSelectTagTemplate_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxSelectTagTemplate)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: MtxSelectTagTemplate,
        selectors: [["", "ng-tag-tmp", ""]]
      });
    }
  }
  return MtxSelectTagTemplate;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MtxSelectLoadingSpinnerTemplate = /*#__PURE__*/(() => {
  class MtxSelectLoadingSpinnerTemplate {
    constructor() {
      this.template = inject(TemplateRef);
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MtxSelectLoadingSpinnerTemplate_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxSelectLoadingSpinnerTemplate)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: MtxSelectLoadingSpinnerTemplate,
        selectors: [["", "ng-loadingspinner-tmp", ""]]
      });
    }
  }
  return MtxSelectLoadingSpinnerTemplate;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MtxSelectPlaceholderTemplate = /*#__PURE__*/(() => {
  class MtxSelectPlaceholderTemplate {
    constructor() {
      this.template = inject(TemplateRef);
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MtxSelectPlaceholderTemplate_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxSelectPlaceholderTemplate)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: MtxSelectPlaceholderTemplate,
        selectors: [["", "ng-placeholder-tmp", ""]]
      });
    }
  }
  return MtxSelectPlaceholderTemplate;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MtxSelectClearbuttonTemplate = /*#__PURE__*/(() => {
  class MtxSelectClearbuttonTemplate {
    constructor() {
      this.template = inject(TemplateRef);
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MtxSelectClearbuttonTemplate_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxSelectClearbuttonTemplate)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: MtxSelectClearbuttonTemplate,
        selectors: [["", "ng-clearbutton-tmp", ""]]
      });
    }
  }
  return MtxSelectClearbuttonTemplate;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** Injection token that can be used to specify default select options. */
const MTX_SELECT_DEFAULT_OPTIONS = new InjectionToken('mtx-select-default-options');
let nextUniqueId = 0;
let MtxSelect = /*#__PURE__*/(() => {
  class MtxSelect {
    get clearSearchOnAdd() {
      return this._clearSearchOnAdd ?? this.closeOnSelect;
    }
    set clearSearchOnAdd(value) {
      this._clearSearchOnAdd = value;
    }
    get items() {
      return this._items;
    }
    set items(value) {
      this._itemsAreUsed = true;
      this._items = value;
    }
    /** Value of the select control. */
    get value() {
      return this._value;
    }
    set value(newValue) {
      const hasAssigned = this._assignValue(newValue);
      if (hasAssigned) {
        this._onChange(newValue);
      }
    }
    /** Unique id of the element. */
    get id() {
      return this._id;
    }
    set id(value) {
      this._id = value || this._uid;
      this.stateChanges.next();
    }
    /** Placeholder to be shown if value is empty. */
    get placeholder() {
      return this._placeholder;
    }
    set placeholder(value) {
      this._placeholder = value;
      this.stateChanges.next();
    }
    /** Whether the select is focused. */
    get focused() {
      return this._focused;
    }
    /** Whether the select has a value. */
    get empty() {
      return this.value == null || Array.isArray(this.value) && this.value.length === 0;
    }
    /**
     * Implemented as part of MatFormFieldControl.
     * @docs-private
     */
    get shouldLabelFloat() {
      return this.focused || !this.empty;
    }
    /** Whether the component is required. */
    get required() {
      return this._required ?? this.ngControl?.control?.hasValidator(Validators.required) ?? false;
    }
    set required(value) {
      this._required = value;
      this.stateChanges.next();
    }
    /** Object used to control when error messages are shown. */
    get errorStateMatcher() {
      return this._errorStateTracker.matcher;
    }
    set errorStateMatcher(value) {
      this._errorStateTracker.matcher = value;
    }
    /** Whether or not the overlay panel is open. */
    get panelOpen() {
      return !!this.ngSelect.isOpen;
    }
    /** Whether the select is in an error state. */
    get errorState() {
      return this._errorStateTracker.errorState;
    }
    set errorState(value) {
      this._errorStateTracker.errorState = value;
    }
    constructor() {
      this._intl = inject(MtxSelectIntl);
      this._changeDetectorRef = inject(ChangeDetectorRef);
      this._elementRef = inject(ElementRef);
      this._focusMonitor = inject(FocusMonitor);
      this.ngControl = inject(NgControl, {
        optional: true,
        self: true
      });
      this._parentFormField = inject(MAT_FORM_FIELD, {
        optional: true
      });
      this._defaultOptions = inject(MTX_SELECT_DEFAULT_OPTIONS, {
        optional: true
      });
      this._document = inject(DOCUMENT);
      this.addTag = false;
      this.appearance = 'underline';
      this.appendTo = this._defaultOptions?.appendTo ?? 'body';
      this.bindLabel = this._defaultOptions?.bindLabel;
      this.bindValue = this._defaultOptions?.bindValue;
      this.closeOnSelect = true;
      this.clearable = true;
      this.clearOnBackspace = true;
      this.dropdownPosition = 'auto';
      this.bufferAmount = 4;
      this.selectableGroup = false;
      this.selectableGroupAsModel = true;
      this.hideSelected = false;
      this.loading = false;
      this.labelForId = null;
      this.markFirst = true;
      this.multiple = false;
      this.searchable = true;
      this.readonly = false;
      this.searchFn = null;
      this.searchWhileComposing = true;
      this.selectOnTab = false;
      this.trackByFn = null;
      this.inputAttrs = {};
      this.openOnEnter = this._defaultOptions?.openOnEnter ?? true;
      this.minTermLength = 0;
      this.editableSearchTerm = false;
      this.keyDownFn = _ => true;
      this.virtualScroll = this._defaultOptions?.virtualScroll ?? false;
      this.fixedPlaceholder = this._defaultOptions?.fixedPlaceholder ?? false;
      this.deselectOnClick = this._defaultOptions?.deselectOnClick ?? false;
      this.blurEvent = new EventEmitter();
      this.focusEvent = new EventEmitter();
      this.changeEvent = new EventEmitter();
      this.openEvent = new EventEmitter();
      this.closeEvent = new EventEmitter();
      this.searchEvent = new EventEmitter();
      this.clearEvent = new EventEmitter();
      this.addEvent = new EventEmitter();
      this.removeEvent = new EventEmitter();
      this.scroll = new EventEmitter();
      this.scrollToEnd = new EventEmitter();
      this._clearSearchOnAdd = this._defaultOptions?.clearSearchOnAdd;
      this._items = [];
      this._itemsAreUsed = false;
      /** Emits whenever the component is destroyed. */
      this._destroy$ = new Subject();
      this._value = null;
      /** Implemented as part of MatFormFieldControl. */
      this.stateChanges = new Subject();
      /** Unique id for this select. */
      this._uid = `mtx-select-${nextUniqueId++}`;
      this._focused = false;
      /** Whether the select is disabled. */
      this.disabled = false;
      /** Aria label of the select. */
      this.ariaLabel = '';
      /** Input that can be used to specify the `aria-labelledby` attribute. */
      this.ariaLabelledby = null;
      /** The aria-describedby attribute on the select for improved a11y. */
      this._ariaDescribedby = null;
      /** A name for this control that can be used by `mat-form-field`. */
      this.controlType = 'mtx-select';
      /** `View -> model callback called when value changes` */
      this._onChange = () => {};
      /** `View -> model callback called when select has been touched` */
      this._onTouched = () => {};
      /** ID for the DOM node containing the select's value. */
      this._valueId = `mtx-select-value-${nextUniqueId++}`;
      this._intlChangesSubscription = Subscription.EMPTY;
      const _focusMonitor = this._focusMonitor;
      const defaultErrorStateMatcher = inject(ErrorStateMatcher);
      const parentForm = inject(NgForm, {
        optional: true
      });
      const parentFormGroup = inject(FormGroupDirective, {
        optional: true
      });
      const ngControl = this.ngControl;
      this._intlChangesSubscription = this._intl.changes.subscribe(() => {
        this._changeDetectorRef.detectChanges();
      });
      _focusMonitor.monitor(this._elementRef, true).subscribe(origin => {
        if (this._focused && !origin) {
          this._onTouched();
        }
        this._focused = !!origin;
        this.stateChanges.next();
      });
      if (this.ngControl) {
        // Note: we provide the value accessor through here, instead of
        // the `providers` to avoid running into a circular import.
        this.ngControl.valueAccessor = this;
      }
      this._errorStateTracker = new _ErrorStateTracker(defaultErrorStateMatcher, ngControl, parentFormGroup, parentForm, this.stateChanges);
      // Force setter to be called in case id was not specified.
      // eslint-disable-next-line no-self-assign
      this.id = this.id;
    }
    ngOnInit() {
      // Fix compareWith warning of undefined value
      // https://github.com/ng-select/ng-select/issues/1537
      if (this.compareWith) {
        this.ngSelect.compareWith = this.compareWith;
      }
    }
    ngAfterViewInit() {
      if (!this._itemsAreUsed) {
        this.ngSelect.escapeHTML = false;
        this._setItemsFromMtxOptions();
      }
    }
    ngDoCheck() {
      if (this.ngControl) {
        const ngControl = this.ngControl;
        // The disabled state might go out of sync if the form group is swapped out. See #17860.
        if (this._previousControl !== ngControl.control) {
          if (this._previousControl !== undefined && ngControl.disabled !== null && ngControl.disabled !== this.disabled) {
            this.disabled = ngControl.disabled;
          }
          this._previousControl = ngControl.control;
        }
        this.updateErrorState();
      }
    }
    ngOnDestroy() {
      this._destroy$.next();
      this._destroy$.complete();
      this.stateChanges.complete();
      this._focusMonitor.stopMonitoring(this._elementRef);
      this._intlChangesSubscription.unsubscribe();
    }
    /** Gets the value for the `aria-labelledby` attribute of the inputs. */
    _getAriaLabelledby() {
      if (this.ariaLabel) {
        return null;
      }
      const labelId = this._parentFormField?.getLabelId();
      let value = (labelId ? labelId + ' ' : '') + this._valueId;
      if (this.ariaLabelledby) {
        value += ' ' + this.ariaLabelledby;
      }
      return value;
    }
    /** Implemented as part of MatFormFieldControl. */
    setDescribedByIds(ids) {
      this._ariaDescribedby = ids.length ? ids.join(' ') : null;
    }
    /**
     * Disables the select. Part of the ControlValueAccessor interface required
     * to integrate with Angular's core forms API.
     *
     * @param isDisabled Sets whether the component is disabled.
     */
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
      this._changeDetectorRef.markForCheck();
      this.stateChanges.next();
    }
    /** Implemented as part of MatFormFieldControl. */
    onContainerClick(event) {
      const target = event.target;
      if (!target.classList.contains('ng-arrow-wrapper')) {
        this.focus();
        this.open();
      }
    }
    /**
     * Sets the select's value. Part of the ControlValueAccessor interface
     * required to integrate with Angular's core forms API.
     *
     * @param value New value to be written to the model.
     */
    writeValue(value) {
      this._assignValue(value);
    }
    /**
     * Saves a callback function to be invoked when the select's value
     * changes from user input. Part of the ControlValueAccessor interface
     * required to integrate with Angular's core forms API.
     *
     * @param fn Callback to be triggered when the value changes.
     */
    registerOnChange(fn) {
      this._onChange = fn;
    }
    /**
     * Saves a callback function to be invoked when the select is blurred
     * by the user. Part of the ControlValueAccessor interface required
     * to integrate with Angular's core forms API.
     *
     * @param fn Callback to be triggered when the component has been touched.
     */
    registerOnTouched(fn) {
      this._onTouched = fn;
    }
    /** Refreshes the error state of the select. */
    updateErrorState() {
      this._errorStateTracker.updateErrorState();
    }
    /** Assigns a specific value to the select. Returns whether the value has changed. */
    _assignValue(newValue) {
      // Always re-assign an array, because it might have been mutated.
      if (newValue !== this._value || this.multiple && Array.isArray(newValue)) {
        this._value = newValue;
        this._changeDetectorRef.markForCheck();
        return true;
      }
      return false;
    }
    /** NgSelect's `_setItemsFromNgOptions` */
    _setItemsFromMtxOptions() {
      const mapMtxOptions = options => {
        this.items = options.map(option => ({
          $ngOptionValue: option.value,
          $ngOptionLabel: option.elementRef.nativeElement.innerHTML,
          disabled: option.disabled
        }));
        this.ngSelect.itemsList.setItems(this.items);
        if (this.ngSelect.hasValue) {
          this.ngSelect.itemsList.mapSelectedItems();
        }
        this.ngSelect.detectChanges();
      };
      const handleOptionChange = () => {
        const changedOrDestroyed = merge(this.mtxOptions.changes, this._destroy$);
        merge(...this.mtxOptions.map(option => option.stateChange$)).pipe(takeUntil(changedOrDestroyed)).subscribe(option => {
          const item = this.ngSelect.itemsList.findItem(option.value);
          item.disabled = option.disabled;
          item.label = option.label || item.label;
          this.ngSelect.detectChanges();
        });
      };
      this.mtxOptions.changes.pipe(startWith(this.mtxOptions), takeUntil(this._destroy$)).subscribe(options => {
        mapMtxOptions(options);
        handleOptionChange();
      });
    }
    open() {
      this.ngSelect.open();
    }
    close() {
      this.ngSelect.close();
    }
    focus() {
      this.ngSelect.focus();
    }
    blur() {
      this.ngSelect.blur();
    }
    openChange() {
      this.openEvent.emit();
      // TODO: The ng-select has no `panelClass` prop, so we can add the theme color by the following way.
      setTimeout(() => {
        const dropdownEl = this._document.getElementById(this.ngSelect.dropdownId);
        dropdownEl?.classList.add('mat-' + this._parentFormField?.color);
      });
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MtxSelect_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxSelect)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MtxSelect,
        selectors: [["mtx-select"]],
        contentQueries: function MtxSelect_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, MtxSelectOptionTemplate, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, MtxSelectOptgroupTemplate, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, MtxSelectLabelTemplate, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, MtxSelectMultiLabelTemplate, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, MtxSelectHeaderTemplate, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, MtxSelectFooterTemplate, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, MtxSelectNotFoundTemplate, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, MtxSelectTypeToSearchTemplate, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, MtxSelectLoadingTextTemplate, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, MtxSelectTagTemplate, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, MtxSelectLoadingSpinnerTemplate, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, MtxSelectPlaceholderTemplate, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, MtxSelectClearbuttonTemplate, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, MtxOption, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.optionTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.optgroupTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.labelTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.multiLabelTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.notFoundTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.typeToSearchTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.loadingTextTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tagTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.loadingSpinnerTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.placeholderTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.clearbuttonTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.mtxOptions = _t);
          }
        },
        viewQuery: function MtxSelect_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c1, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ngSelect = _t.first);
          }
        },
        hostAttrs: ["role", "combobox", "aria-autocomplete", "none", 1, "mtx-select"],
        hostVars: 20,
        hostBindings: function MtxSelect_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id)("aria-expanded", ctx.panelOpen)("aria-label", ctx.ariaLabel || null)("aria-labelledby", ctx._getAriaLabelledby())("aria-describedby", ctx._ariaDescribedby || null)("aria-required", ctx.required.toString())("aria-disabled", ctx.disabled.toString())("aria-invalid", ctx.errorState);
            i0.ɵɵclassProp("mtx-select-floating", ctx.shouldLabelFloat)("mtx-select-disabled", ctx.disabled)("mtx-select-invalid", ctx.errorState)("mtx-select-required", ctx.required)("mtx-select-empty", ctx.empty)("mtx-select-multiple", ctx.multiple);
          }
        },
        inputs: {
          addTag: "addTag",
          addTagText: "addTagText",
          appearance: "appearance",
          appendTo: "appendTo",
          bindLabel: "bindLabel",
          bindValue: "bindValue",
          closeOnSelect: [2, "closeOnSelect", "closeOnSelect", booleanAttribute],
          clearAllText: "clearAllText",
          clearable: [2, "clearable", "clearable", booleanAttribute],
          clearOnBackspace: [2, "clearOnBackspace", "clearOnBackspace", booleanAttribute],
          compareWith: "compareWith",
          dropdownPosition: "dropdownPosition",
          groupBy: "groupBy",
          groupValue: "groupValue",
          bufferAmount: "bufferAmount",
          selectableGroup: [2, "selectableGroup", "selectableGroup", booleanAttribute],
          selectableGroupAsModel: [2, "selectableGroupAsModel", "selectableGroupAsModel", booleanAttribute],
          hideSelected: [2, "hideSelected", "hideSelected", booleanAttribute],
          loading: [2, "loading", "loading", booleanAttribute],
          loadingText: "loadingText",
          labelForId: "labelForId",
          markFirst: [2, "markFirst", "markFirst", booleanAttribute],
          maxSelectedItems: "maxSelectedItems",
          multiple: [2, "multiple", "multiple", booleanAttribute],
          notFoundText: "notFoundText",
          searchable: [2, "searchable", "searchable", booleanAttribute],
          readonly: [2, "readonly", "readonly", booleanAttribute],
          searchFn: "searchFn",
          searchWhileComposing: [2, "searchWhileComposing", "searchWhileComposing", booleanAttribute],
          selectOnTab: [2, "selectOnTab", "selectOnTab", booleanAttribute],
          trackByFn: "trackByFn",
          inputAttrs: "inputAttrs",
          tabIndex: "tabIndex",
          openOnEnter: [2, "openOnEnter", "openOnEnter", booleanAttribute],
          minTermLength: "minTermLength",
          editableSearchTerm: [2, "editableSearchTerm", "editableSearchTerm", booleanAttribute],
          keyDownFn: "keyDownFn",
          virtualScroll: [2, "virtualScroll", "virtualScroll", booleanAttribute],
          typeToSearchText: "typeToSearchText",
          typeahead: "typeahead",
          isOpen: "isOpen",
          fixedPlaceholder: [2, "fixedPlaceholder", "fixedPlaceholder", booleanAttribute],
          deselectOnClick: [2, "deselectOnClick", "deselectOnClick", booleanAttribute],
          clearSearchOnAdd: "clearSearchOnAdd",
          items: "items",
          value: "value",
          id: "id",
          placeholder: "placeholder",
          disabled: [2, "disabled", "disabled", booleanAttribute],
          required: [2, "required", "required", booleanAttribute],
          errorStateMatcher: "errorStateMatcher",
          ariaLabel: [0, "aria-label", "ariaLabel"],
          ariaLabelledby: [0, "aria-labelledby", "ariaLabelledby"]
        },
        outputs: {
          blurEvent: "blur",
          focusEvent: "focus",
          changeEvent: "change",
          openEvent: "open",
          closeEvent: "close",
          searchEvent: "search",
          clearEvent: "clear",
          addEvent: "add",
          removeEvent: "remove",
          scroll: "scroll",
          scrollToEnd: "scrollToEnd"
        },
        exportAs: ["mtxSelect"],
        features: [i0.ɵɵProvidersFeature([{
          provide: MatFormFieldControl,
          useExisting: MtxSelect
        }])],
        decls: 15,
        vars: 63,
        consts: [["ngSelect", ""], [3, "ngModelChange", "blur", "focus", "change", "open", "close", "search", "clear", "add", "remove", "scroll", "scrollToEnd", "ngModel", "ngModelOptions", "placeholder", "items", "addTag", "addTagText", "appendTo", "appearance", "bindLabel", "bindValue", "closeOnSelect", "clearAllText", "clearable", "clearOnBackspace", "dropdownPosition", "groupBy", "groupValue", "bufferAmount", "hideSelected", "isOpen", "inputAttrs", "loading", "loadingText", "labelForId", "markFirst", "maxSelectedItems", "multiple", "notFoundText", "readonly", "typeahead", "typeToSearchText", "trackByFn", "searchable", "searchFn", "searchWhileComposing", "clearSearchOnAdd", "selectableGroup", "selectableGroupAsModel", "selectOnTab", "tabIndex", "openOnEnter", "minTermLength", "editableSearchTerm", "keyDownFn", "virtualScroll", "fixedPlaceholder", "deselectOnClick"], ["ng-option-tmp", ""], ["ng-optgroup-tmp", ""], ["ng-label-tmp", ""], ["ng-multi-label-tmp", ""], ["ng-header-tmp", ""], ["ng-footer-tmp", ""], ["ng-notfound-tmp", ""], ["ng-typetosearch-tmp", ""], ["ng-loadingtext-tmp", ""], ["ng-tag-tmp", ""], ["ng-loadingspinner-tmp", ""], ["ng-placeholder-tmp", ""], ["ng-clearbutton-tmp", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "ngTemplateOutlet"]],
        template: function MtxSelect_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "ng-select", 1, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function MtxSelect_Template_ng_select_ngModelChange_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.value, $event) || (ctx.value = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("blur", function MtxSelect_Template_ng_select_blur_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.blurEvent.emit($event));
            })("focus", function MtxSelect_Template_ng_select_focus_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.focusEvent.emit($event));
            })("change", function MtxSelect_Template_ng_select_change_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.changeEvent.emit($event));
            })("open", function MtxSelect_Template_ng_select_open_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.openChange());
            })("close", function MtxSelect_Template_ng_select_close_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.closeEvent.emit());
            })("search", function MtxSelect_Template_ng_select_search_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.searchEvent.emit($event));
            })("clear", function MtxSelect_Template_ng_select_clear_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.clearEvent.emit($event));
            })("add", function MtxSelect_Template_ng_select_add_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.addEvent.emit($event));
            })("remove", function MtxSelect_Template_ng_select_remove_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.removeEvent.emit($event));
            })("scroll", function MtxSelect_Template_ng_select_scroll_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.scroll.emit($event));
            })("scrollToEnd", function MtxSelect_Template_ng_select_scrollToEnd_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.scrollToEnd.emit());
            });
            i0.ɵɵtemplate(2, MtxSelect_Conditional_2_Template, 1, 0, null, 2)(3, MtxSelect_Conditional_3_Template, 1, 0, null, 3)(4, MtxSelect_Conditional_4_Template, 1, 0, null, 4)(5, MtxSelect_Conditional_5_Template, 1, 0, null, 5)(6, MtxSelect_Conditional_6_Template, 1, 0, null, 6)(7, MtxSelect_Conditional_7_Template, 1, 0, null, 7)(8, MtxSelect_Conditional_8_Template, 1, 0, null, 8)(9, MtxSelect_Conditional_9_Template, 1, 0, null, 9)(10, MtxSelect_Conditional_10_Template, 1, 0, null, 10)(11, MtxSelect_Conditional_11_Template, 1, 0, null, 11)(12, MtxSelect_Conditional_12_Template, 1, 0, null, 12)(13, MtxSelect_Conditional_13_Template, 1, 0, null, 13)(14, MtxSelect_Conditional_14_Template, 1, 0, null, 14);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("ng-select-invalid", ctx.errorState);
            i0.ɵɵtwoWayProperty("ngModel", ctx.value);
            i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(62, _c2))("placeholder", ctx.placeholder || ctx._intl.placeholder)("items", ctx.items)("addTag", ctx.addTag)("addTagText", ctx.addTagText || ctx._intl.addTagText)("appendTo", ctx.appendTo)("appearance", ctx.appearance)("bindLabel", ctx.bindLabel)("bindValue", ctx.bindValue)("closeOnSelect", ctx.closeOnSelect)("clearAllText", ctx.clearAllText || ctx._intl.clearAllText)("clearable", ctx.clearable)("clearOnBackspace", ctx.clearOnBackspace)("dropdownPosition", ctx.dropdownPosition)("groupBy", ctx.groupBy)("groupValue", ctx.groupValue)("bufferAmount", ctx.bufferAmount)("hideSelected", ctx.hideSelected)("isOpen", ctx.isOpen)("inputAttrs", ctx.inputAttrs)("loading", ctx.loading)("loadingText", ctx.loadingText || ctx._intl.loadingText)("labelForId", ctx.labelForId)("markFirst", ctx.markFirst)("maxSelectedItems", ctx.maxSelectedItems)("multiple", ctx.multiple)("notFoundText", ctx.notFoundText || ctx._intl.notFoundText)("readonly", ctx.readonly || ctx.disabled)("typeahead", ctx.typeahead)("typeToSearchText", ctx.typeToSearchText || ctx._intl.typeToSearchText)("trackByFn", ctx.trackByFn)("searchable", ctx.searchable)("searchFn", ctx.searchFn)("searchWhileComposing", ctx.searchWhileComposing)("clearSearchOnAdd", ctx.clearSearchOnAdd)("selectableGroup", ctx.selectableGroup)("selectableGroupAsModel", ctx.selectableGroupAsModel)("selectOnTab", ctx.selectOnTab)("tabIndex", ctx.tabIndex)("openOnEnter", ctx.openOnEnter)("minTermLength", ctx.minTermLength)("editableSearchTerm", ctx.editableSearchTerm)("keyDownFn", ctx.keyDownFn)("virtualScroll", ctx.virtualScroll)("fixedPlaceholder", ctx.fixedPlaceholder)("deselectOnClick", ctx.deselectOnClick);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.optionTemplate ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.optgroupTemplate ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.labelTemplate ? 4 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.multiLabelTemplate ? 5 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.headerTemplate ? 6 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.footerTemplate ? 7 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.notFoundTemplate ? 8 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.typeToSearchTemplate ? 9 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.loadingTextTemplate ? 10 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.tagTemplate ? 11 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.loadingSpinnerTemplate ? 12 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.placeholderTemplate ? 13 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.clearbuttonTemplate ? 14 : -1);
          }
        },
        dependencies: [NgSelectModule, i1.NgSelectComponent, i1.NgOptgroupTemplateDirective, i1.NgOptionTemplateDirective, i1.NgLabelTemplateDirective, i1.NgMultiLabelTemplateDirective, i1.NgHeaderTemplateDirective, i1.NgFooterTemplateDirective, i1.NgPlaceholderTemplateDirective, i1.NgNotFoundTemplateDirective, i1.NgTypeToSearchTemplateDirective, i1.NgLoadingTextTemplateDirective, i1.NgTagTemplateDirective, i1.NgLoadingSpinnerTemplateDirective, i1.NgClearButtonTemplateDirective, FormsModule, i2.NgControlStatus, i2.NgModel, NgTemplateOutlet],
        styles: [".ng-select{padding:var(--mat-form-field-filled-with-label-container-padding-top, 24px) 16px var(--mat-form-field-filled-with-label-container-padding-bottom, 8px);margin:calc(var(--mat-form-field-filled-with-label-container-padding-top, 24px) * -1) -16px calc(var(--mat-form-field-filled-with-label-container-padding-bottom, 8px) * -1)}.mdc-text-field--outlined .ng-select,.mdc-text-field--no-label .ng-select{padding-top:var(--mat-form-field-container-vertical-padding, 16px);padding-bottom:var(--mat-form-field-container-vertical-padding, 16px);margin-top:calc(var(--mat-form-field-container-vertical-padding, 16px) * -1);margin-bottom:calc(var(--mat-form-field-container-vertical-padding, 16px) * -1)}.ng-select .ng-select-container{align-items:center;color:var(--mtx-select-container-text-color, var(--mat-sys-on-surface))}.ng-select .ng-select-container .ng-value-container{align-items:center;gap:4px}.ng-select .ng-select-container .ng-value-container .ng-input>input{height:var(--mat-form-field-container-text-line-height, var(--mat-sys-body-large-line-height));color:inherit;font:inherit}.ng-select .ng-select-container .ng-clear-wrapper{display:inline-flex;justify-content:center;align-items:center;width:24px;height:var(--mat-form-field-container-text-line-height, var(--mat-sys-body-large-line-height))}.ng-select .ng-placeholder{transition:opacity .2s;opacity:1;color:var(--mtx-select-placeholder-text-color, color-mix(in srgb, var(--mat-sys-on-surface) 38%, transparent))}.mat-form-field-hide-placeholder .ng-select .ng-placeholder{opacity:0}.ng-select .ng-has-value .ng-placeholder{display:none}.ng-select .ng-clear-wrapper{color:var(--mtx-select-clear-icon-color, var(--mat-sys-on-surface))}.ng-select .ng-clear-wrapper:hover .ng-clear{color:var(--mtx-select-clear-icon-hover-color, var(--mat-sys-error))}.ng-select.ng-select-disabled .ng-value{color:var(--mtx-select-disabled-text-color, color-mix(in srgb, var(--mat-sys-on-surface) 38%, transparent))}.ng-select.ng-select-opened .ng-arrow-wrapper .ng-arrow{top:-2px;border-width:0 5px 5px}.ng-select.ng-select-single.ng-select-filtered .ng-placeholder{display:initial;visibility:hidden}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value{display:inline-flex;align-items:center;height:var(--mat-form-field-container-text-line-height, var(--mat-sys-body-large-line-height));padding:0 calc((var(--mat-form-field-container-text-line-height, var(--mat-sys-body-large-line-height)) - 16px) / 2);border-radius:9999px;font-size:.875em;background-color:var(--mtx-select-multiple-value-background-color, transparent);border:1px solid var(--mtx-select-multiple-value-outline-color, var(--mat-sys-outline))}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value.ng-value-disabled{opacity:.4}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-label{display:inline-block;margin:0 4px;line-height:16px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon{width:16px;height:16px;line-height:16px;border-radius:50%;text-align:center}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon:hover{background-color:var(--mtx-select-multiple-value-icon-hover-background-color, var(--mat-sys-outline-variant))}.ng-select.ng-select-multiple.ng-select-disabled .ng-select-container .ng-value-container .ng-value{border-color:var(--mtx-select-multiple-value-disabled-outline-color, color-mix(in srgb, var(--mat-sys-outline) 38%, transparent))}.ng-select .ng-arrow-wrapper{width:10px}.ng-select .ng-arrow{border-width:5px 5px 2px;border-style:solid;border-color:var(--mtx-select-enabled-arrow-color, var(--mat-sys-on-surface)) transparent transparent}.ng-select.ng-select-disabled .ng-arrow{border-color:var(--mtx-select-disabled-arrow-color, color-mix(in srgb, var(--mat-sys-on-surface) 38%, transparent)) transparent transparent}.ng-select.ng-select-invalid .ng-arrow{border-color:var(--mtx-select-invalid-arrow-color, var(--mat-sys-error)) transparent transparent}.ng-select.ng-select-opened .ng-arrow{border-color:transparent transparent var(--mtx-select-enabled-arrow-color, var(--mat-sys-on-surface))}.ng-select.ng-select-opened.ng-select-invalid .ng-arrow{border-color:transparent transparent var(--mtx-select-invalid-arrow-color, var(--mat-sys-error))}.ng-dropdown-panel{background-color:var(--mtx-select-panel-background-color, var(--mat-sys-surface-container))}.ng-dropdown-panel.ng-select-bottom{top:100%;border-bottom-left-radius:var(--mtx-select-container-shape, var(--mat-sys-corner-extra-small));border-bottom-right-radius:var(--mtx-select-container-shape, var(--mat-sys-corner-extra-small));box-shadow:var(--mtx-select-container-elevation-shadow, 0px 3px 1px -2px rgba(0, 0, 0, .2), 0px 2px 2px 0px rgba(0, 0, 0, .14), 0px 1px 5px 0px rgba(0, 0, 0, .12))}.ng-dropdown-panel.ng-select-top{bottom:100%;border-top-left-radius:var(--mtx-select-container-shape, var(--mat-sys-corner-extra-small));border-top-right-radius:var(--mtx-select-container-shape, var(--mat-sys-corner-extra-small));box-shadow:var(--mtx-select-container-elevation-shadow, 0px 3px 1px -2px rgba(0, 0, 0, .2), 0px 2px 2px 0px rgba(0, 0, 0, .14), 0px 1px 5px 0px rgba(0, 0, 0, .12))}.ng-dropdown-panel .ng-dropdown-header,.ng-dropdown-panel .ng-dropdown-footer{padding:14px 16px}.ng-dropdown-panel .ng-dropdown-header{border-bottom:1px solid var(--mtx-select-panel-divider-color, var(--mat-sys-outline))}.ng-dropdown-panel .ng-dropdown-footer{border-top:1px solid var(--mtx-select-panel-divider-color, var(--mat-sys-outline))}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup{padding:14px 16px;font-weight:500;-webkit-user-select:none;user-select:none;cursor:pointer;color:var(--mtx-select-optgroup-label-text-color, var(--mat-sys-on-surface))}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-disabled{cursor:default}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-marked{background-color:var(--mtx-select-option-hover-state-background-color, color-mix(in srgb, var(--mat-sys-on-surface) calc(var(--mat-sys-hover-state-layer-opacity) * 100%), transparent))}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-selected{background-color:var(--mtx-select-option-selected-state-background-color, var(--mat-sys-secondary-container));color:var(--mtx-select-option-selected-state-text-color, var(--mat-sys-on-surface))}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option{position:relative;padding:14px 16px;text-overflow:ellipsis;text-decoration:none;text-align:left;white-space:nowrap;overflow:hidden;color:var(--mtx-select-option-label-text-color, var(--mat-sys-on-surface))}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-marked{background-color:var(--mtx-select-option-hover-state-background-color, color-mix(in srgb, var(--mat-sys-on-surface) calc(var(--mat-sys-hover-state-layer-opacity) * 100%), transparent))}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected{background-color:var(--mtx-select-option-selected-state-background-color, var(--mat-sys-secondary-container));color:var(--mtx-select-option-selected-state-text-color, var(--mat-sys-on-surface))}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-disabled{color:var(--mtx-select-option-disabled-state-text-color, color-mix(in srgb, var(--mat-sys-on-surface) 38%, transparent))}[dir=rtl] .ng-dropdown-panel .ng-dropdown-panel-items .ng-option{text-align:right}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-child{padding-left:32px}[dir=rtl] .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-child{padding-right:32px;padding-left:0}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option .ng-tag-label{margin-right:6px;font-size:80%}[dir=rtl] .ng-dropdown-panel .ng-dropdown-panel-items .ng-option .ng-tag-label{margin-left:6px;margin-right:0}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return MtxSelect;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MtxSelectModule = /*#__PURE__*/(() => {
  class MtxSelectModule {
    /** @nocollapse */static {
      this.ɵfac = function MtxSelectModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxSelectModule)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: MtxSelectModule
      });
    }
    /** @nocollapse */
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, ReactiveFormsModule, NgSelectModule, MtxSelect]
      });
    }
  }
  return MtxSelectModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { MTX_SELECT_DEFAULT_OPTIONS, MtxOption, MtxSelect, MtxSelectClearbuttonTemplate, MtxSelectFooterTemplate, MtxSelectHeaderTemplate, MtxSelectIntl, MtxSelectLabelTemplate, MtxSelectLoadingSpinnerTemplate, MtxSelectLoadingTextTemplate, MtxSelectModule, MtxSelectMultiLabelTemplate, MtxSelectNotFoundTemplate, MtxSelectOptgroupTemplate, MtxSelectOptionTemplate, MtxSelectPlaceholderTemplate, MtxSelectTagTemplate, MtxSelectTypeToSearchTemplate };
